import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  LocationDetailRecord,
  LocationDetailsResponse,
} from '../../screens/NavigatorReports/pages/PerfectTruckAnalytics/perfectTruckKpiApi';

// ─── State ────────────────────────────────────────────────────────────────────

interface PerfectTruckLocationSummaryState {
  data: LocationDetailRecord[];
  total: number;
  page: number;
  size: number;
  totalPages: number;
  loading: boolean;
  error: string | null;
}

const initialState: PerfectTruckLocationSummaryState = {
  data: [],
  total: 0,
  page: 0,
  size: 10,
  totalPages: 0,
  loading: false,
  error: null,
};

// ─── Slice ────────────────────────────────────────────────────────────────────

const perfectTruckLocationSummarySlice = createSlice({
  name: 'perfectTruckLocationSummary',
  initialState,
  reducers: {
    setLocationSummaryLoading(state) {
      state.loading = true;
      state.error = null;
    },

    setLocationSummaryData(state, action: PayloadAction<LocationDetailsResponse>) {
      const { data, total, page, size, totalPages } = action.payload;
      state.data = data;
      state.total = total;
      state.page = page;
      state.size = size;
      state.totalPages = totalPages;
      state.loading = false;
      state.error = null;
    },

    setLocationSummaryError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    resetLocationSummary() {
      return initialState;
    },
  },
});

export const {
  setLocationSummaryLoading,
  setLocationSummaryData,
  setLocationSummaryError,
  resetLocationSummary,
} = perfectTruckLocationSummarySlice.actions;

export default perfectTruckLocationSummarySlice.reducer;
